import PaxAccountContent from './pax-account-content';

export default PaxAccountContent;
